import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @gandi/gandi/no-private-import
export const InputText = extraProps => {
  return /*#__PURE__*/_jsx("input", {
    type: "text",
    className: "form-control",
    ...extraProps
  });
};